/** Maximum number of pages allowed per scan session. */
export const MAX_SCAN_PAGES = 30;

export const JPEG_CAPTURE_QUALITY = 0.82;
export const JPEG_PDF_QUALITY = 0.78;
export const PDF_MARGIN_PT = 30;

export const JSCANIFY_SCRIPT_URL =
  'https://cdn.jsdelivr.net/gh/ColonelParrot/jscanify@master/src/jscanify.min.js';

/** Primary OpenCV build (docs.opencv.org). */
export const OPENCV_SCRIPT_URL = 'https://docs.opencv.org/4.8.0/opencv.js';

/**
 * Optional self-hosted copy under public/opencv/opencv.js.
 * Used only when the file is present (avoids SPA index.html being parsed as JS).
 */
export const OPENCV_LOCAL_SCRIPT_PATH = `${process.env.PUBLIC_URL ?? ''}/opencv/opencv.js`.replace(
  /\/{2,}/g,
  '/'
);

export const ACCEPTED_UPLOAD_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const;

export const ACCEPTED_UPLOAD_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.pdf',
  '.doc',
  '.docx',
] as const;

export const ACCEPTED_UPLOAD_ACCEPT_ATTR =
  '.jpg,.jpeg,.png,.pdf,.doc,.docx,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
